import {connect} from 'react-redux';
import QuickSearch from '../components/quicksearch/quicksearch';

const mapStateToProps = (state) => {
  return {
    idxExclusions: state.store.entity.siteOptions.idxExclusions,
    regionUrlParts: state.store.entity.regionUrlParts,
    supportsMls: state.store.entity.supportsMls
  };
};

export default connect(mapStateToProps)(QuickSearch);



// WEBPACK FOOTER //
// ./src/containers/quicksearch.js